/** 项目列表全局风险提醒：独立分页，避免被搜索、语言和使用中筛选隐藏。 */
import { useEffect, useState } from 'react';
import { useLandingProjectBookVisibilityWarnings } from '~/data/queries';
import { Pagination } from '~/ui/Pagination';
import { LandingProjectBookVisibilityAlert } from './LandingProjectBookVisibilityAlert';

export function LandingProjectBookVisibilityWarnings({ onOpen }: { onOpen: (id: string) => void }) {
  const [page, setPage] = useState(1);
  const query = useLandingProjectBookVisibilityWarnings(page);
  const lastPage = Math.max(1, Math.ceil((query.data?.total ?? 0) / 20));
  useEffect(() => {
    if (query.data && page > lastPage) setPage(lastPage);
  }, [query.data, page, lastPage]);
  if (query.isPending) return <div role="status">正在核对项目关联书籍的公开状态…</div>;
  return (
    <LandingProjectBookVisibilityAlert
      warnings={query.data?.data ?? []}
      total={query.data?.total ?? 0}
      onOpen={onOpen}
      error={query.isError}
    >
      {query.isError ? (
        <button
          type="button"
          className="btn btn-ghost btn-sm"
          style={{ color: 'inherit' }}
          onClick={() => void query.refetch()}
        >
          重新核验
        </button>
      ) : query.data && query.data.total > 20 ? (
        <Pagination total={query.data.total} page={page} pageSize={20} onChange={setPage} />
      ) : null}
    </LandingProjectBookVisibilityAlert>
  );
}
